export default __webpack_public_path__ + "static/media/oil.e54fec00.png";